const BookingStatuses = {
    1: 'Pendiente de Pago',
    2: 'Confirmada',
    3: 'Pago Rechazado',
    4: 'Pendiente Cancelación Pago',
    5: 'Cancelada',
}

export default BookingStatuses